<template lang="pug">
.actions-filters
  v-card(
    color="secondary"
    dark
  ).sdo-card
    v-scroll-y-transition(leave-absolute)
      v-card-text(v-if="loading")
        v-skeleton-loader.fill-width(
          type=`
            card-heading,
            list-item-two-line@5
          `
        )
    v-card-text(v-if="!loading")
      v-list(
        nav
        dense
        color="transparent"
      )
        v-subheader.mb-2
          .text-uppercase Фильтрация
          v-spacer
          template(v-if="units.selected.length")
            v-btn(
              rounded
              depressed
              light
              small
              color="white"
              @click="setUnits([], true)"
            ).ml-2
              span(v-if="courseOnly") Выбрано: {{ selectedCourses.length }}
              span(v-else) Выбрано тем: {{ units.selected.length }}
              v-icon(right) mdi-close
        v-scroll-x-transition(leave-absolute)
          div(v-if="!courses.selected")
            v-list-item(
              v-for="course in coursesList"
              :key="course.id"
              inactive
              @click="!courseOnly ? courses.selected = course : courseToggleCheckbox(course)"
            ).py-1.cursor-pointer
              v-list-item-avatar
                v-checkbox(
                  value
                  :input-value="courseIsAllUnitsSelected(course)"
                  :indeterminate="courseSelectedUnitsIndeteriminate(course)"
                  :readonly="courseOnly"
                  @change="courseToggleCheckbox(course)"
                ).px-2
              v-list-item-content {{ course.title }}
              v-list-item-action(v-if="!courseOnly")
                v-btn(icon): v-icon mdi-chevron-right

      v-scroll-x-reverse-transition(hide-on-leave)
        v-list(
          v-if="courses.selected"
          nav
          dense
          color="transparent"
        )
          v-list-item(
            v-if="courses.selected"
            @click="courses.selected = null"
          )
            v-list-item-icon
              v-icon mdi-chevron-left
            v-list-item-content
              v-list-item-subtitle Вернуться
          v-list-item(
            @click="courseToggleCheckbox(courses.selected)"
          )
            v-list-item-action
              v-checkbox(
                value
                :input-value="courseIsAllUnitsSelected(courses.selected)"
                :indeterminate="courseSelectedUnitsIndeteriminate(courses.selected)"
              )
            v-list-item-content
              v-list-item-title.pre-wrap: strong
                | {{ courses.selected.title }}
            v-list-item-action(v-if="!courses.selected")
              v-icon mdi-chevron-right
          v-list-item-group(
            :value="units.selected"
            multiple
            @change="setUnits($event, true)"
          ).ml-10.mt-3
            v-list-item(
              v-for="unit in unitsByCourse[courses.selected.id]"
              :key="unit.id"
              :value="unit.id"
            )
              template(#default="{ active }")
                v-list-item-action
                  v-checkbox(
                    :input-value="active"
                    hide-details
                  )
                v-list-item-content
                  v-list-item-title.pre-wrap {{ unit.title }}
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    storageKey: { type: String, default: 'teaching' },
    courseOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      unitsByCourse: {},

      courses: {
        items: [],
        selected: null,
      },
      units: {
        items: [],
        selected: [],
      },

      loading: true,
    };
  },
  computed: {
    coursesList() {
      return this.courses.selected ? [this.courses.selected] : this.courses.items;
    },
    selectedCourses() {
      return this.courses.items.filter(
        (i) => this.courseIsAllUnitsSelected(i),
      ).map((i) => i.id);
    },
    tags() {
      const units = this.units.items.filter(
        (i) => this.units.selected.includes(i.id) && !this.selectedCourses.includes(i.course_id),
      );

      return [
        ...units.map((i) => ({
          course_id: i.course_id,
          course_unit_id: i.id,
        })),
        ...this.selectedCourses.map((id) => ({
          course_id: id,
        })),
      ];
    },
  },
  watch: {
    'courses.selected': function (val) {
      if (!val) {
        this.courses.selected = null;
      }
    },
  },
  async created() {
    this.loading = true;
    await this.fetchCourses();
    await this.fetchUnits();
    await this.fetchConfig();
    this.loading = false;
  },
  methods: {
    setUnits(units, commit) {
      this.units.selected = units;
      if (commit) {
        this.saveConfig();
      }
      this.$emit('input', this.tags);
    },
    async fetchConfig() {
      const units = [];
      const { course } = this.$route.query;
      if (course) {
        this.unitsByCourse[course].forEach((unit) => {
          units.push(unit.id);
        });
      } else {
        const { items } = await this.$api.userData.index({
          'search[owner_id]': this.$user.data.id,
          'search[key]': this.storageKey,
        });
        const [tag] = items;
        if (tag) {
          tag.data.forEach((i) => {
            if (!i.course_unit_id) {
              if (this.unitsByCourse[i.course_id]) {
                this.unitsByCourse[i.course_id].forEach((unit) => {
                  units.push(unit.id);
                });
              }
            } else units.push(i.course_unit_id);
          });
        }
      }
      this.setUnits(units.filter((item, index) => units.indexOf(item) === index), !course);
    },
    saveConfig() {
      this.$api.userData.create({
        key: this.storageKey,
        data: this.tags,
      });
    },
    fetchCourses() {
      return this.$rHandler(
        this.$api.courses.getCourseList({
          'search[teacher_or_curator]': this.$user.data.id,
          'search[has_prior_records]': true,
          expand: 'course_units',
        }),
        (resp) => {
          this.courses.items = resp.data.data;
        },
      );
    },
    async fetchUnits() {
      const coursesIds = this.courses.items.map((i) => i.id);

      const { items } = await this.$api.courseUnits.index({
        'search[course_id]': coursesIds,
        'per-page': -1,
        expand: 'courses,course_modules',
      });
      this.units.items = items.filter((i) => i.courses.length);
      this.unitsByCourse = this.units.items.reduce((acc, item) => {
        if (acc[item.courses[0].id]) acc[item.courses[0].id].push(item);
        else return { ...acc, [item.courses[0].id]: [item] };

        return acc;
      }, {});
    },
    courseIsAllUnitsSelected(course) {
      if (!this.unitsByCourse[course.id]) return false;
      return this.unitsByCourse[course.id].every((i) => this.units.selected.includes(i.id));
    },
    courseSelectedUnitsIndeteriminate(course) {
      if (!this.unitsByCourse[course.id] || this.courseIsAllUnitsSelected(course)) return false;
      return !!this.unitsByCourse[course.id].find((i) => this.units.selected.includes(i.id));
    },
    courseSelectAllUnits(course) {
      if (!this.unitsByCourse[course.id]) return;

      this.units.selected = _.union(
        this.units.selected,
        this.unitsByCourse[course.id].map((i) => i.id),
      );
    },
    courseResetSelection(course) {
      this.units.selected = _.without(
        this.units.selected,
        ...this.unitsByCourse[course.id].map((i) => i.id),
      );
    },
    async courseToggleCheckbox(course) {
      if (this.courseIsAllUnitsSelected(course)) {
        this.courseResetSelection(course);
      } else {
        this.courseSelectAllUnits(course);
      }
      this.setUnits(this.units.selected, true);
    },
  },
};
</script>
